var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content has-padding"},[_c('ui-page-hero',{attrs:{"title":'Active carts'}}),_c('section',{staticClass:"section is-small"},[_c('div',{staticClass:"container"},[_c('cart-list')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }